import { api } from './api';
import { unauthorizedError } from './state';

export const grantCapability = (payload) => async (dispatch) => {
  dispatch({ type: 'GRANT_CAPABILITY_LOADING' });

  try {
    const response = await api.post('/admin/capability-grant', payload);

    dispatch({
      type: 'GRANT_CAPABILITY_SUCCESS',
      data: response.data,
    });

    return response.data;
  } catch (error) {
    dispatch({ type: 'GRANT_CAPABILITY_ERROR', error: error.response?.data || error.message });

    if (error.response?.status === 401) {
      dispatch(unauthorizedError());
    }

    throw error;
  }
};

export const resetCapabilityGrant = () => (dispatch) => {
  dispatch({ type: 'RESET_CAPABILITY_GRANT' });
};
